@if (countActiveFilters > 0) {
<button
  color="primary"
  mat-button
  [matTooltip]="filterName"
  (click)="open()"
  [matBadge]="countActiveFilters"
  matBadgePosition="after"
  matBadgeColor="accent"
>
  {{ filterName }}
  <mat-icon class="d-flex" svgIcon="expand_more" iconPositionEnd></mat-icon>
</button>
} @else {

<button color="primary" mat-button matTooltip="Filtrar" (click)="open()">
  {{ filterName }}
  <mat-icon class="d-flex" svgIcon="expand_more" iconPositionEnd></mat-icon>
</button>

}
